import FetchService from "./Shared/FetchService";
const baseURL = "/aviso/configurationSearch";
export default class ConfigurationService {
    static getDisableManualAlertsConfiguration() {
        return FetchService.getSingleResponse(baseURL + "/findByKey", {
            key: "disableManualAlert",
            // Convert from string to boolean
        }).then((val) => val === "true");
    }
    static getConfiguration(key) {
        return FetchService.getSingleResponse(baseURL + "/findByKey", {
            key,
        });
    }
    static getIntConfiguration(key) {
        return ConfigurationService.getConfiguration(key).then((config) => parseInt(config, 10));
    }
}
